import * as React from 'react';
import { config } from '../../../config';
import { biLogger } from '../../../bi';
import { Modal, MessageBoxFunctionalLayout } from 'wix-style-react';
import { composer } from '../../../component-decorators/composer';
export var ConnectDomainModal = composer()
    .withTranslation()
    .withMarketplaceStore()
    .compose(function (_a) {
    var t = _a.t, appId = _a.appId, msid = _a.msid, marketplaceStore = _a.marketplaceStore, appName = _a.appName;
    var handleClose = function () {
        // tslint:disable-next-line: no-floating-promises
        biLogger.appMarketCloseDialogBoxOfConnectDomainX({
            app_id: appId,
            msid: msid,
        });
        marketplaceStore.closeAllModals();
    };
    var handleConnect = function () {
        // tslint:disable-next-line: no-floating-promises
        biLogger.appMarketConnectDomainClick({
            app_id: appId,
            msid: msid,
        });
        window.open("https://www.wix.com/dashboard/" + marketplaceStore.metaSiteId + "/manage-website/domains?referralInfo=marketplace" + config.origin + "',");
    };
    // tslint:disable-next-line: no-floating-promises
    biLogger.appMarketUpgradeSiteConnectDomainDialogBox({
        appId: appId,
        msid: msid,
        stepName: 'connect_domain',
    });
    return (React.createElement(Modal, { isOpen: true },
        React.createElement(MessageBoxFunctionalLayout, { title: t('modals-connectDomain-header', { appName: appName }), confirmText: t('modals-connectDomain-cta'), cancelText: t('modals-connectDomain-cancel'), theme: "blue", closeButton: true, onClose: function () { return handleClose(); }, onCancel: function () { return handleClose(); }, onOk: function () { return handleConnect(); }, image: React.createElement("img", { src: config.marketplaceStaticsUrl + "assets/images/connect-domain.png" }) }, t('modals-connectDomain-content', { appName: appName }))));
});
//# sourceMappingURL=connect-domain-modal.js.map